/* jshint esversion: 6 */

/**
 * Whether a row on Short Links is the account's default: a shortener, No Shortener (id 0) among
 * them, by the default shortener, and a custom domain by the default domain. The account keeps a
 * default domain alongside a default shortener of 0, so No Shortener is the default only when no
 * domain is.
 */
export default function isDefaultShortener(item, defaultSaId, defaultPdId) {
	let id = parseInt(item.id, 10),
		saId = parseInt(defaultSaId, 10) || 0,
		pdId = parseInt(defaultPdId, 10) || 0;

	if ((parseInt(item.ssID, 10) || 0) > 0 || id === 0) {
		return saId === id && !(id === 0 && pdId > 0);
	}

	return pdId === id;
}
